var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61131 0.912109C10.7932 0.912104 11.9635 1.14489 13.0555 1.59718C14.1474 2.04947 15.1396 2.7124 15.9753 3.54813C16.811 4.38385 17.4739 5.37601 17.9262 6.46794C18.3785 7.55987 18.6113 8.73019 18.6113 9.91209C18.6113 14.8827 14.5819 18.9121 9.61131 18.9121C4.64078 18.9121 0.611328 14.8827 0.611328 9.91209C0.611328 4.94156 4.64078 0.912109 9.61131 0.912109ZM10.5113 10.8121H8.71132C6.48319 10.8121 4.57028 12.1616 3.74522 14.0879C5.05067 15.9184 7.1916 17.1121 9.61131 17.1121C12.031 17.1121 14.1719 15.9184 15.4774 14.0878C14.6524 12.1616 12.7395 10.8121 10.5113 10.8121ZM9.61131 3.61211C8.12015 3.61211 6.91131 4.82095 6.91131 6.31211C6.91131 7.80326 8.12015 9.0121 9.61131 9.0121C11.1025 9.0121 12.3113 7.80326 12.3113 6.31211C12.3113 4.82095 11.1025 3.61211 9.61131 3.61211Z",
    fill: "#22D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/userFill.f6ecf74d7a8388fd78294aa5e84401d9.svg";
export { ForwardRef as ReactComponent };